import { useSalesChannelType } from '@/src/constrains/SalesChannelHOC/useSalesChannel';
import { currentSelectedStyle } from '@/src/constrains/SalesChannelStyleSelect/slice';
import { ChannelType, WebSiteSubType } from '@/src/types/common/SalesChannel';
import React from 'react';
import { useSelector } from 'react-redux';
import SalesChannelEditorHeader from './salesChannelEditorHeader';
import SalesChannelEditorHeaderResponsive from './salesChannelEditorHeaderResponsive';

export default (props) => {
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  const isNative =
    useSelector(currentSelectedStyle()) === WebSiteSubType.NativeMobile;
  return isMini || isNative ? (
    <SalesChannelEditorHeader />
  ) : (
    <SalesChannelEditorHeaderResponsive />
  );
};
